import {Observable} from 'rxjs/Observable';
import {OauthService} from '../../oauth.service';
import {Http} from '@angular/http';
import {App} from 'ionic-angular';
import {Injectable} from '@angular/core';
import {ArticleList} from '../../../models/article/article-list.model';
import {ToolsService} from '../../tools.service';
import {AppProvider} from "../../../../core/app/app-provider.service";

@Injectable()
export class ArticleRepositoryService extends OauthService {

  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
  ) {
    super(http, app, appProvider, tools);
  }

  /**
   * @param {number} produitId
   * @returns {Observable<ArticleList[]>}
   */
  public findAvailableArticle(produitId: any, sourceDeDonnees: string): Observable<ArticleList[]> {
    if (produitId === null || produitId === undefined) {
      throw new Error('Required parameter produitId was null or undefined when calling findAvailableArticle.');
    }

    const url = this.Routing.generate('api_get_produits_articles',
      {
        '_format': 'json',
        'produitId': produitId,
        'sourceDeDonnees': sourceDeDonnees
      }, true);

    return this.http
      .get(url, {headers: this.updateHeaders()})
      .map(response => {
        return response.json().data as ArticleList[];
      });
  }

  public getOffres(sousgenresId: string, date: string, onglet: string, duree: string): Observable<ArticleList[]> {
    const url = this.Routing.generate('api_get_produits_offres',
      {
        '_format': 'json',
        'sousgenresId': sousgenresId,
        'date': date,
        'onglet': onglet,
        'duree' : duree
      }, true);

    return this.http
      .get(url, {headers: this.updateHeaders()}).timeout(10000)
      .map(response => {
        return response.json().data as ArticleList[];
      });
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/repository/symfony-api/article-repository.service.ts